/**
 * Where each background-job detail page lives.
 *
 * One place for the three paths, so the lists, the view pages and the links
 * between them cannot drift. Ids are raw, matching the job and schedule forms.
 *
 * A schedule carries `?jobId=` because there is no GET /schedules/{id}: its page
 * finds it by listing the owning job's schedules, the same way the edit form does.
 */
export const jobPath = (jobId: string) => `/background-jobs/jobs/${jobId}`;

export const runPath = (runId: string) => `/background-jobs/runs/${runId}`;

export const schedulePath = (s: { _id: string; jobId: string }) =>
  `/background-jobs/schedules/${s._id}?jobId=${s.jobId}`;
